import { ReactNode } from "react";

export type FormCardV2Props = {
  title?: string;
  description?: ReactNode;
  children: ReactNode;
  actions?: ReactNode;
};

export function FormCardV2({ title, description, children, actions }: FormCardV2Props) {
  return (
    <section className="ov2-card">
      {(title || description || actions) && (
        <header className="ov2-card__header">
          <div>
            {title && <h2>{title}</h2>}
            {description && <p>{description}</p>}
          </div>
          {actions && <div className="ov2-card__actions">{actions}</div>}
        </header>
      )}
      <div className="ov2-card__body">{children}</div>
    </section>
  );
}
